import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";
const Index = () => {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) {
      toast.error("Por favor, introduce un código");
      return;
    }
    setIsLoading(true);
    try {
      const trimmedCode = code.trim();
      
      // Si es un código de referido (empieza con "R"), validar que sea un número válido
      if (trimmedCode.startsWith('R')) {
        const submissionId = trimmedCode.substring(1);
        if (isNaN(parseInt(submissionId))) {
          toast.error("Código de referido inválido");
          return;
        }
        // Los códigos de referido se validan en la Edge Function, no aquí
        navigate(`/${trimmedCode}`);
        return;
      }

      // Para códigos normales, verificar si existe en form_codes (buscar en todos los proyectos)
      const {
        data,
        error
      } = await supabase.from("form_codes").select("code, project_id").eq("code", trimmedCode).maybeSingle();
      if (error) {
        throw error;
      }
      if (!data) {
        toast.error("Código no válido");
        return;
      }

      // Redirigir al usuario a la página con el código
      navigate(`/${trimmedCode}`);
    } catch (error: any) {
      toast.error(error.message || "Error al verificar el código");
      console.error("Error al verificar el código:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      {/* Logo superior */}
      <div className="mb-6">
        <img src="/lovable-uploads/b567a654-97e5-4401-9513-2574e8dbf7f0.png" alt="3M Líder Logo" className="h-auto w-auto max-h-24 object-contain" />
      </div>
      
      <div className={`w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-[0_4px_6px_-1px_rgba(0,0,0,0.05)] ${isMobile ? 'mx-8' : ''}`}>
        <div className="flex flex-col items-center justify-center space-y-4">
          <h1 className="text-3xl font-bold">Líder 3m</h1>
          <p className="text-gray-500">Introduce el código para acceder a tu cuestionario</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Input id="code" type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Introduce tu código" className="w-full text-center" autoFocus required />
          </div>
          
          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? "Verificando..." : "Continuar"}
          </Button>
        </form>
      </div>
      
      {/* Crescente logo y copyright */}
      <div className="mt-6 flex flex-col items-center">
        <img src="https://crescente.es/wp-content/uploads/2025/03/cropped-icono-crescente-2.png" alt="Crescente Logo" className="h-auto w-auto max-h-8 object-contain opacity-75" />
        <p className="text-xs text-gray-300 mt-2">3m | Crescente © 2025</p>
      </div>
    </div>;
};
export default Index;